import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
});

// --- Courses ---
export const getCourses = () => api.get('/courses');
export const getCourse = (key) => api.get(`/courses/${key}`);
export const createCourse = (data) => api.post('/courses', data);
export const updateCourse = (key, data) => api.put(`/courses/${key}`, data);
export const deleteCourse = (key) => api.delete(`/courses/${key}`);
export const getImportHistory = (key) => api.get(`/courses/${key}/import/history`);
export const getCourseAnalytics = (key) => api.get(`/courses/${key}/analytics`);
export const getCourseTopLearners = (key, limit = 100) => api.get(`/courses/${key}/analytics/learners?limit=${limit}`);

// --- Import ---
export const uploadFiles = (formData) =>
  api.post('/import/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const prescanFile = (filePath, fileType) =>
  api.post('/import/prescan', { filePath, fileType });

export const executeImport = (data) => api.post('/import/execute', data);

// --- Batch ---
export const getBatchStats = () => api.get('/batch/stats');
export const getBatchStatus = () => api.get('/batch/status');
export const runBatchImport = () => api.post('/batch/run');

export default api;
